export class CategorieArticle {
    aca_id: number;
    aca_code: string;
    aca_libelle: string;

    constructor(init: Partial<CategorieArticle>) {
        for (let prop in init) {
            this[prop] = init[prop];
        }
    }

    get computed_name(): string {
        return `[${this.aca_code}] ${this.aca_libelle}`;
    }

    toJSON() {
        const type: any = {};
        Object.assign(type, this);
        return JSON.stringify(type);
    }
}